export default __webpack_public_path__ + "static/media/151-seventeen.3740af62.png";